import mixpanel from "mixpanel-browser";
import { https, httpsPublic } from "../http";
import store from "../store";
import {
  _login,
  setEmailVerifyLoading,
  setLoading,
  setForgotLoading,
  setResetLoading,
  setContactUs,
} from "../store/reducers/auth";
import {
  clearSession,
  setCookie,
  showError,
  showInfo,
  showSuccess,
} from "../utils/index";
import { getProfile } from "./profile";
import swal from "sweetalert";
import { userInfoAnalytics } from "../config/mixpanelConfig";
import { getAllStaff, getAllStaffSkypoint } from "./staff";
import { getPackages } from "./package";
import { selectSkyPointPlan } from "./subscription";

const login = async (values, navigate) => {
  try {
    // Submitting credentials always starts a fresh session — drop any previous
    // user's cookie/store BEFORE authenticating so a failed or abandoned login
    // can't fall back into the old account. Must happen here (not after
    // getProfile) or it would wipe the profile we just fetched.
    clearSession();
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/login", values);
    const { message, token, user } = response?.data;
    let profile = await getProfile(true, response?.data?.token);
    console.log("🚀 ~ login ~ profile:", profile)

    if (response?.status === 200) {
      if (message === "Email Verified") {
        if (token) {
          setCookie(token, "token");
          if (profile.user?.user?.type !== "staff") {
            // if (!profile?.user?.business) {
            //   navigate("/signup", { state: { token: token } });
            //   // navigate("/selectprice");
            // } else 
              if (profile.user.business && !profile.user.subscription) {
              navigate("/selectprice");
            } else {
              navigate("/home");
            }
          } else {
            navigate("/home");
          }
        } else {
          navigate("/select-2fa-method", {
            state: { user: response.data.user },
          });
          store.dispatch(_login({ token }));
        }
      } else if (message === "Verification Email Sent") {
        showInfo("Verification Email Sent");
      }
      store.dispatch(setLoading(false));

      // console.log("response login", response);
      // let profile = await getProfile(true, response?.data?.token);
      // if (profile) {
      //   userInfoAnalytics(profile);
      //   let { token, user, message } = response?.data;
      //   if (message === "Email Verified") {
      //     setCookie(token, "token");
      //     if (user?.user?.type !== "staff") {
      //       // console.log("user", user);
      //       if (user?.business) {
      //         // navigate("/selectprice");
      //       } else if (!user?.business) {
      //         // navigate("/profile");
      //         navigate("/signup", { state: { token: token } });
      //       } else if (user?.business && user?.subscription) {
      //         navigate("/select-2fa-method");
      //       }
      //     } else navigate("/select-2fa-method");
      //     store.dispatch(_login({ token }));
      //   } else if (message === "Verification Email Sent") {
      //     showInfo("Verification Email Sent");
      //   }
      // }
      // let profile = await getProfile(true, response?.data?.token);
      // if (profile) {
      //   // console.log("profile on login", profile)
      //   // mixpanel.identify(profile?.user?.user?.id);
      //   // mixpanel.people.set({
      //   //   $name: profile?.user?.user?.name,
      //   //   $email: profile?.user?.user?.email,
      //   //   $avatar: profile?.user?.user?.photo,
      //   // });
      //   userInfoAnalytics(profile);
      //   let { token, user, message } = response?.data;
      //   if (message === "Email Verified") {
      //     setCookie(token, "token");
      //     if (profile?.user?.user?.type !== "staff") {
      //       // console.log("user", user);
      //       if (profile?.user?.business) {
      //         // navigate("/selectprice");
      //       } else if (!profile?.user?.business) {
      //         // navigate("/profile");
      //         navigate("/signup", { state: { token: token } });
      //       } else if (profile?.user?.business && profile?.user?.subscription) {
      //         if (profile?.user?.user?.twoFactorType) {
      //           navigate("/2fa");
      //         } else {
      //           navigate("/select-2fa-method");
      //         }
      //       }
      //     } else
      //       profile?.user?.user?.twoFactorType
      //         ? navigate("/2fa")
      //         : navigate("/select-2fa-method");
      //     store.dispatch(_login({ token }));
      //   } else if (message === "Verification Email Sent") {
      //     showInfo("Verification Email Sent");
      //   }
      // }
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

const login_Skypoint = async (values, navigate) => {
  try {
    clearSession();
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/skypoint/login", values);
    const { message, token, user } = response?.data;
    let profile = await getProfile(true, response?.data?.token);

    if (response?.status === 200) {
      if (message === "Email Verified") {
        if (token) {
          setCookie(token, "token");
          // if (profile.user?.user?.type !== "staff") {
              navigate("/home/dashboard-skypoint");
          // }
            if (profile.user.business && !profile.user.subscription) {
              try {
                const data = await getPackages(profile?.user?.id);
                const freePackage = data?.packages
                  ?.filter((pkg) => pkg.type === "skypoint" && Number(pkg.cost) === 0)
                  ?.[0];
                if (freePackage) {
                  await selectSkyPointPlan({ id: freePackage.id });
                  await getProfile(true, response?.data?.token);
                }
              } catch (err) {
                console.error("Failed to auto-assign free plan:", err);
              }
            }
            navigate("/home/dashboard-skypoint");
        } else {
          // 2FA required: only a pendingToken for the 2FA endpoints (OD-1482).
          navigate("/skypoint-select-2fa-method", {
            state: { user: response.data.user, pendingToken: response.data.pendingToken },
          });
          store.dispatch(_login({ token }));
        }
      } else if (message === "Verification Email Sent") {
        showInfo("Verification Email Sent");
      }
      store.dispatch(setLoading(false));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

const send2faCode = async (values, navigate) => {
  try {
    let response = await https().post("/auth/send-2fa", values);
    if (response?.status === 200) {
      showInfo(response?.data?.message || "");
      navigate("/2fa", {
        state: { user: response.data.user, pendingToken: values?.pendingToken },
      });
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const send2faCodeSkypoint = async (values, navigate) => {
  try {
    let response = await https().post("/auth/skypoint/send-2fa", values);
    console.log("🚀 ~ send2faCode ~ response:", response);
    if (response?.status === 200) {
      showInfo(response?.data?.message || "");
      navigate("/skypoint-2fa", {
        state: { user: response.data.user, pendingToken: values?.pendingToken },
      });
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const verify2fa = async (values, navigate) => {
  try {
    clearSession();
    let response = await https().post("/auth/verify-2fa", values);
    if (response?.status === 200) {
      let profile = await getProfile(true, response?.data?.token);
      if (profile) {
        userInfoAnalytics(profile);
        let { token, user, message } = response?.data;
        if (token) {
          setCookie(token, "token");
          console.log("here testing profile", profile);

          if (profile.user?.user?.type !== "staff") {
            // console.log("user", user);
            if (!profile?.user?.business) {
              navigate("/signup",);
              // navigate("/selectprice");
            } else if (profile.user.business && !profile.user.subscription) {
              navigate("/selectprice");
            } else {
              navigate("/home");
            }
          } else {
            navigate("/home");
          }
          // else navigate("/select-2fa-method");
          store.dispatch(_login({ token }));
        }
      }
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
    if (
      resData?.user &&
      resData?.user?.lockUntil &&
      new Date(resData.user.lockUntil) > new Date()
    ) {
      navigate("/login", { replace: true });
    }
  }
};

const verify2faSkypoint = async (values, navigate) => {
  try {
    clearSession();
    let response = await https().post("/auth/skypoint/verify-2fa", values);
    if (response?.status === 200) {
      let profile = await getProfile(true, response?.data?.token);
      if (profile) {
        userInfoAnalytics(profile);
        let { token, user, message } = response?.data;
        if (token) {
          setCookie(token, "token");
          console.log("here testing profile", profile);
          navigate("/home/dashboard-skypoint");
          store.dispatch(_login({ token }));
        }
      }
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
    if (
      resData?.user &&
      resData?.user?.lockUntil &&
      new Date(resData.user.lockUntil) > new Date()
    ) {
      navigate("/skypoint-login", { replace: true });
    }
  }
};

const resetStaff2FA = async (values, navigate) => {
  try {
    let response = await https().post("/auth/reset-staff-2fa", values);
    if (response?.status === 200) {
      // let profile = await getProfile(true, response?.data?.token);
    getAllStaff("all");
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
  }
};

const resetStaff2FASkypoint = async (values, navigate) => {
  try {
    let response = await https().post("/auth/skypoint/reset-staff-2fa", values);
    if (response?.status === 200) {
      // let profile = await getProfile(true, response?.data?.token);
    getAllStaffSkypoint("all");
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
  }
};

const staffAndProfile2fa = async (values, navigate) => {
  try {
    let response = await https().post("/auth/staff-profile-verify-2fa", values);
    if (response?.status === 200) {
      // let profile = await getProfile(true, response?.data?.token);
    getAllStaff("all");
      return response?.data;
    }
  } catch (error) {
    const resData = error?.response?.data;
    showError(resData?.error || resData?.message || "Something went wrong");
  }
};

const resend2fa = async (values) => {
  try {
    let response = await https().post("/auth/resend-code", values);
    if (response?.status === 200) {
      showSuccess(response?.data?.message);
      return response?.data;
    }
  } catch (error) {
    showError(
      error?.response?.data?.error || error?.response?.data?.message,
      error?.response?.status
    );
  }
};

const resend2faSkypoint = async (values) => {
  try {
    let response = await https().post("/auth/skypoint/resend-code", values);
    if (response?.status === 200) {
      showSuccess(response?.data?.message);
      return response?.data;
    }
  } catch (error) {
    showError(
      error?.response?.data?.error || error?.response?.data?.message,
      error?.response?.status
    );
  }
}

const verifyTwoFactor = async (values) => {
  try {
    let response = await https().post("/auth/verify-two-factor", values);
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message);
  }
};

const twoFactorSettings = async (values) => {
  try {
    let response = await https().post("/auth/two-factor-settings", values);
    if (response?.status === 200) {
      getProfile();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message);
  }
};

// google login
const googleLogin = async (values, navigate) => {
  try {
    clearSession();
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/skypoint/google-auth", values);
    if (response?.status === 200) {
      // 2FA required (OD-1482): same picker as the password login.
      if (!response?.data?.token && response?.data?.pendingToken) {
        store.dispatch(setLoading(false));
        navigate("/skypoint-select-2fa-method", {
          state: { user: response.data.user, pendingToken: response.data.pendingToken },
        });
        return;
      }
      let profile = await getProfile(true, response?.data?.token);
      if (profile) {
        let { token, user } = response?.data;
        // console.log("user :", user);
        setCookie(token, "token");
        if (profile.user?.user?.type !== "staff") {
            // console.log("user", user);
            if (!profile?.user?.business) {
              navigate("/skypoint-signup");
            } else if (profile.user.business && !profile.user.subscription) {
              navigate("/skypoint-packages");
            } else {
              navigate("/home/dashboard-skypoint");
            }
          } else {
            navigate("/home/dashboard-skypoint");
          }
        // if (user?.user?.type !== "staff") {
        //   if (user?.business) {
        //     navigate("/selectprice");
        //   } else if (!user?.business) {
        //     navigate("/profile");
        //   } else if (user?.business && user?.subscription) {
        //     navigate("/home");
        //   }
        // } else navigate("/home");
        store.dispatch(_login({ token }));
      }
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

// google sign up
const googleSignup = async (values, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/decode-token", values);
    if (response?.status === 200) {
      clearSession();
      setCookie(response?.data?.user?.token, "token");
      store.dispatch(setLoading(false));
      navigate("/profile");
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status, false);
  }
};

const signUp = async (values) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/sign-up", values);
    if (response?.status === 200) {
      clearSession();
      setCookie(response?.data?.user?.token, "token");
      store.dispatch(setLoading(false));
      // navigate("/profile");
      await swal({
        title: `Email Verification`,
        text: "Email verification link sent successfully. Please verify your email address",
        icon: "success",
        dangerMode: false,
        buttons: ["Cancel", "Ok"],
      });
      return response;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return error?.response;
  }
};
const skypointSignUp = async (values) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/skypoint-sign-up", values);
    if (response?.status === 200) {
      clearSession();
      setCookie(response?.data?.user?.token, "token");
      store.dispatch(setLoading(false));
      // navigate("/profile");
      await swal({
        title: `Email Verification`,
        text: "Email verification link sent successfully. Please verify your email address",
        icon: "success",
        dangerMode: false,
        buttons: ["Cancel", "Ok"],
      });
      return response;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return error?.response;
  }
};

const registerBusiness = async (values, navigate) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().post("/auth/business", values);

    if (response?.status === 200) {
      await getProfile(true, response?.data?.token);
      store.dispatch(setLoading(false));
      return response;
      // navigate("/selectprice");
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    const duplicate = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("duplicate");
    const companyName = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("companyname");
    // console.log("erroe in sercice", error?.response?.data?.message);
    const businessEmail = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("businessemail");
    const contactPhone = error?.response?.data?.message
      ?.toLowerCase()
      ?.includes("contactphone");

    if (duplicate && companyName)
      return showError("Company name alreay in use.");
    if (duplicate && businessEmail)
      return showError("Company Email alreay in use.");
    if (duplicate && contactPhone)
      return showError("Company Number alreay in use.");
    else showError(error?.response?.data?.message, error?.response?.status);
  }
};

const forgetPassword = async (values, navigate) => {
  try {
    store.dispatch(setForgotLoading(true));
    let response = await https().post("/auth/forgotPassword", values);

    if (response?.status === 200) {
      store.dispatch(setForgotLoading(false));
      showInfo(response?.data?.message);
    }
  } catch (error) {
    store.dispatch(setForgotLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const forgetPasswordSkypoint = async (values, navigate) => {
  try {
    store.dispatch(setForgotLoading(true));
    let response = await https().post("/auth/forgotPassword-skypoint", values);

    if (response?.status === 200) {
      store.dispatch(setForgotLoading(false));
      showInfo(response?.data?.message);
    }
  } catch (error) {
    store.dispatch(setForgotLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const resetPassword = async (values, navigate) => {
  try {
    store.dispatch(setResetLoading(true));
    let response = await https().post("/auth/resetPassword", values);
    console.log("🚀 ~ resetPassword ~ response:", response)
    if (response?.status === 200) {
      showInfo(response?.data?.message);
      clearSession();
      navigate("/skypoint-login");
      store.dispatch(setResetLoading(false));
    }
  } catch (error) {
    store.dispatch(setResetLoading(false));

    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const resetPasswordSkypoint = async (values, navigate) => {
  try {
    store.dispatch(setResetLoading(true));
    let response = await httpsPublic().post("/auth/reset-password-skypoint", values);
    if (response?.status === 200) {
      showInfo(response?.data?.message);
      clearSession();
      navigate("/skypoint-login");
      store.dispatch(setResetLoading(false));
    }
  } catch (error) {
    store.dispatch(setResetLoading(false));

    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const verifyEmail = async (values, navigate) => {
  try {
    store.dispatch(setEmailVerifyLoading(true));
    let response = await https().post("/auth/verifyEmail", values);

    // console.log("response inside verify email");

    if (response?.status === 200) {
      store.dispatch(setEmailVerifyLoading(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setEmailVerifyLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const contactUs = async (values) => {
  try {
    store.dispatch(setContactUs(true));
    let response = await https().post("/auth/contactUs", values);

    if (response?.status === 200) {
      store.dispatch(setContactUs(false));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setContactUs(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};


 const SignupsearchAddress = async (query) => {
  try {
    const response = await https().get("/auth/skypoint/search-address", {
      params: { query },
    });
    if (response?.status === 200) {
      return response.data; // [{ place_id, formatted_address }, ...]
    }
    return [];
  } catch (error) {
    return [];
  }
};

 const getSignupAddressByPlaceId = async (place_id) => {
  try {
    const response = await https().get(
      `/auth/skypoint/get-address-by-placeid/${place_id}`
    );
    if (response?.status === 200) {
      return response.data; // { result: { address_components, formatted_address, ... } }
    }
    return null;
  } catch (error) {
    return null;
  }
};


export {
  login_Skypoint,
  login,
  googleLogin,
  googleSignup,
  signUp,
  skypointSignUp,
  forgetPassword,
  forgetPasswordSkypoint,
  verifyEmail,
  resetPassword,
  registerBusiness,
  contactUs,
  setResetLoading,
  verify2fa,
  verifyTwoFactor,
  send2faCode,
  resend2fa,
  send2faCodeSkypoint,
  verify2faSkypoint,
  resend2faSkypoint,
  twoFactorSettings,
  staffAndProfile2fa,
  resetStaff2FA,
  resetStaff2FASkypoint,
  resetPasswordSkypoint,
  SignupsearchAddress,
  getSignupAddressByPlaceId,
};
